<div class="agpr-formField agpr-imageSettingsField">
    @if (field?.enableInsertUrl) {
        <div class="agpr-imageSettingsField-link">
            <div class="agpr-imageSettingsField-linkLabel">
                <span>
                    {{ 'Common.forms.image.link' | localize }}
                </span>
            </div>

            <agpr-button
                [label]="addLinkLocalization"
                [style]="buttonTypesEnum.tertiary"
                (click)="addLink()"
            >
            </agpr-button>
        </div>

        <div
            *ngIf="!value?.link"
            class="agpr-imageSettingsField-noLink"
        >
            <span>
                {{ 'Common.forms.image.noLink' | localize }}
            </span>
        </div>
    }

    <dl
        *ngIf="value?.link"
        class="agpr-imageSettingsField-linkDetails"
    >
        <dt class="agpr-imageSettingsField-linkDetails-label">
            {{ value.link.url ? ('Common.dialog.linkType.webAddress' | localize) : ('Common.dialog.linkType.emailAddress' | localize) }}
        </dt>
        <dd
            class="agpr-imageSettingsField-linkDetails-content"
            [agprTooltip]="value.link.url ? value.link.url : value.link.email"
            tooltipPosition="top"
        >
            {{ value.link.url || value.link.email }}
        </dd>
    </dl>

    @if (field?.enableAltText && !isCanvas) {
        <agpr-text-input
            label="Common.forms.image.altText"
            tooltip="Common.forms.image.altText.tooltip"
            tooltipPosition="top"
            [(ngModel)]="altText"
            (ngModelChange)="valueChange($event, 'altText')"
            [placeholder]="'Common.forms.image.enterAltText'"
            [id]="'imageField.altText'"
        >
        </agpr-text-input>
    }

    <agpr-textarea-input
        [id]="'imageField.caption'"
        [(ngModel)]="caption"
        (ngModelChange)="valueChange($event, 'caption')"
        [placeholder]="captionPlaceholderStr | localize"
        [label]="captionTitle | localize"
    >
    </agpr-textarea-input>

    <div
        *ngIf="field?.enableDisplaySize"
        class="agpr-formField-label"
        id="field.formFieldSliderLabel"
    >
        <span>
            {{ 'Common.forms.image.imageDisplaySize' | localize }}
        </span>
    </div>

    <agpr-slider-input
        id="image_size_slider"
        *ngIf="field?.enableDisplaySize"
        [(ngModel)]="displaySize"
        (ngModelChange)="displaySizeChange()"
        class="agpr-imageSettingsField-slider"
        [min]="10"
        [max]="100"
        [step]="1"
        leftIcon="fa-regular fa-duotone fa-image"
        leftTooltip="PageBuilder.formField.tooltip.minImageSize"
        rightIcon="fa-regular fa-duotone fa-image"
        rightTooltip="PageBuilder.formField.tooltip.maxImageSize"
        [ariaLabelledBy]="'field.formFieldSliderLabel'"
        [ariaValueText]="displaySize + '%'"
    ></agpr-slider-input>
</div>
